<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <b style="line-height:1.5;">
          <u>
            <span style="font-size:16pt;">Electrode</span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12px;text-indent:18pt;line-height:1.5;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12px;text-indent:18pt;line-height:1.5;">Round Electrode:</span>
      </p>
      <p>
        <span style="text-indent:18pt;font-size:12px;">Carbon Electrode: Diameter</span>
        <span style="text-indent:18pt;font-size:12pt;"></span>
        <span style="text-indent:18pt;font-size:12px;">800mm</span>
        <span style="text-indent:18pt;font-size:12px;">- 1272mm</span>
      </p>
      <p>
        <span style="font-size:12px;">Graphite Electrode</span>
        <span style="font-size:12px;">:</span>
        <span style="font-size:12pt;"></span>
        <span style="font-size:12pt;">
          <span style="font-size:12px;">Diameter</span>
          <span style="font-size:12px;">800mm</span>
        </span>
        <span style="font-size:12px;">-1146mm</span>
      </p>
      <p>
        <img
          :src="images.tszp"
          style="font-family:宋体;font-size:16px;line-height:24px;white-space:normal;"
        >
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
        <span style="font-size:12px;font-family:Arial;">Packet: 914X762X3556mm</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Technical parameters:</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span></span>
        </span>
        <span style="font-size:12px;font-family:Arial;">Real density:</span>
        <span style="font-size:12px;font-family:Arial;">2.00g</span>
        <span style="font-size:12px;font-family:Arial;">/cm3 Min</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <span style="font-size:12.0pt;font-family:Arial;">
        <span></span>
      </span>
      <span style="font-size:12px;font-family:Arial;">Bulk density:</span>
      <span style="font-size:12px;font-family:Arial;">1.54g</span>
      <span style="font-size:12px;font-family:Arial;">/cm3 Min (</span>
      <span style="font-size:12.0pt;font-family:宋体;">
        <span style="font-family:Arial;font-size:12px;">Typical value</span>
        <span style="font-family:Arial;font-size:12px;">1.55-1.56g/cm3)</span>
      </span>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">Flexual strength:</span>
          <span style="font-family:Arial;font-size:12px;">6MPa Min (</span>
          <span style="font-family:Arial;font-size:12px;">Typical value</span>
          <span style="font-family:Arial;font-size:12px;">7MPa)</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Compressive strength:</span>
        <span style="font-size:12px;font-family:Arial;">23MPa Min (</span>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">Typical value</span>
          <span style="font-family:Arial;font-size:12px;">25-26MPa)</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Resistivity:</span>
        <span style="font-size:12px;font-family:Arial;">14μΩm Max (</span>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">Typical value</span>
          <span style="font-family:Arial;font-size:12px;">12-13μΩm)</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Porosity</span>
        <span style="font-size:12px;font-family:Arial;">: 28.7% Max</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Ash:</span>
        <span style="font-size:12px;font-family:Arial;">2.3% Max</span>
      </p>
      <span style="font-size:12.0pt;font-family:宋体;">
        <span style="font-family:Arial;font-size:12px;">Fe 2.07% Max</span>
        <br>
      </span>
      <p>
        <span style="font-size:12px;font-family:Arial;">S 0.05% Max</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        tszp: require("../../../assets/img/common/tszp.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/tszp.vue